import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=4c36a8a9&scoped=true&"
import script from "./UserFilters.vue?vue&type=script&lang=js&"
export * from "./UserFilters.vue?vue&type=script&lang=js&"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=4c36a8a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36a8a9",
  null
  
)

export default component.exports